/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_ud_kind_ulid = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ULID`)
};

const es_ud_kind_ulid = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ULID`)
};

const de_ud_kind_ulid = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ULID`)
};

const nl_ud_kind_ulid = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ULID`)
};

const fr_ud_kind_ulid = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ULID`)
};

const it_ud_kind_ulid = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ULID`)
};

const pt_br2_ud_kind_ulid = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ULID`)
};

const pt_ud_kind_ulid = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ULID`)
};

const ja_ud_kind_ulid = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ULID`)
};

const zh_ud_kind_ulid = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ULID`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const ud_kind_ulid = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.ud_kind_ulid(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("ud_kind_ulid", locale)
	if (locale === "en") return en_ud_kind_ulid(inputs)
	if (locale === "es") return es_ud_kind_ulid(inputs)
	if (locale === "de") return de_ud_kind_ulid(inputs)
	if (locale === "nl") return nl_ud_kind_ulid(inputs)
	if (locale === "fr") return fr_ud_kind_ulid(inputs)
	if (locale === "it") return it_ud_kind_ulid(inputs)
	if (locale === "pt-BR") return pt_br2_ud_kind_ulid(inputs)
	if (locale === "pt") return pt_ud_kind_ulid(inputs)
	if (locale === "ja") return ja_ud_kind_ulid(inputs)
	return zh_ud_kind_ulid(inputs)
};